export function createPageUrl(page) {
  const routes = {
    Home: "/",
    About: "/about",
    Services: "/services",
    Demos: "/demos",
    Contact: "/contact"
  }

  return routes[page] || "/"
}
